import { createAuthClient } from "better-auth/react";
import { adminClient, organizationClient } from "better-auth/client/plugins";
import { adminAc, userAc } from "better-auth/plugins/admin/access";

export const authClient = createAuthClient({
  // Stessi ruoli del server (api/auth.ts): il sysadmin ha i permessi dell'admin.
  plugins: [organizationClient(), adminClient({ roles: { user: userAc, admin: adminAc, sysadmin: adminAc } })],
});

export const {
  useSession,
  signIn,
  signUp,
  signOut,
  getSession,
  organization,
  useListOrganizations,
  useActiveOrganization,
  useActiveMemberRole,
  admin,
  requestPasswordReset,
  resetPassword,
} = authClient;
